export const formatMoney = (amount: any, isDecimal = true) => {
	if (!amount) return null;

	const formatter = isDecimal
		? new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
		  })
		: new Intl.NumberFormat('en-US', {});

	return formatter.format(amount);
};

export const isAnEmptyObject = (obj: any) => {
	for (const key in obj) {
		if (obj?.prototype?.hasOwnProperty?.call(key)) return false;
		// eslint-disable-next-line no-else-return
		else return false;
	}
	return true;
};